import {cdnImage} from '@/util/cdnImage';
import {MUIContainer} from '@/components/MUI-Components';
import DisplayImage from '@/components/Ui-components/display-image';
import {HYBRID_META_DATA} from '@/util/metaData/mobile';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import dynamic from 'next/dynamic';
import PageHead from '@/components/PageHead';

// ─── getStaticProps ─────────────────────────────────────────────────────────
export const getStaticProps = async () => {
    const {
        hybridAppBannerBottom,
        hybridAppDecodingData,
        hybridAppDevelopmentBannerPoints,
        hybridAppFAQ,
        hybridAppIndustryData,
        hybridAppMobileProcessData,
        hybridAppServiceData,
        hybridAppStrategyData,
        hybridAppTechnologyData,
        hybridCarsoulData,
        hybridChooseBodyData,
        hybridChooseContentData,
        hybridDataBusinesses,
        hybridFriendSpireButtonData,
        hybridFriendSpireCheckPoint,
        hybridKeyStrategy
    } = await import('@/util/contents/hybrid-data');

    const {wellPopCheckpoint} = await import('@/util/contents/mobile-app-data');

    const {flutterP2BButtonData, flutterP2BCheckPoint, flutterWellPopButtonData} = await import('@/util/contents/flutter-data');

    return {
        props: {
            hybridAppBannerBottom,
            hybridAppDecodingData,
            hybridAppDevelopmentBannerPoints,
            hybridAppFAQ,
            hybridAppIndustryData,
            hybridAppMobileProcessData,
            hybridAppServiceData,
            hybridAppStrategyData,
            hybridAppTechnologyData,
            hybridCarsoulData,
            hybridChooseBodyData,
            hybridChooseContentData,
            hybridDataBusinesses,
            hybridFriendSpireButtonData,
            hybridFriendSpireCheckPoint,
            hybridKeyStrategy,
            wellPopCheckpoint,
            flutterP2BButtonData,
            flutterP2BCheckPoint,
            flutterWellPopButtonData
        }
    };
};

const Banner = dynamic(import('@/components/Ui-components/Banner'));
const Questions = dynamic(import('@/components/Ui-components/questions'));
const Testimonials = dynamic(import('@/components/Ui-components/Testimonials'));
const LatestInsights = dynamic(import('@/components/Ui-components/latest-insights'));
const Decoding = dynamic(() => import('@/components/Ui-components/Decoding'));
const auditImg = cdnImage('hybrid-app/Hybrid-App-Development.webp');
const HelperSection = dynamic(import('@/components/Ui-components/helper-section'));
const LatestCTA = dynamic(() => import('@/components/Ui-components/LatestCta'));
const Platforms = dynamic(() => import('@/components/Ui-components/platforms'));
const OurServices = dynamic(() => import('@/components/Ui-components/our-services'));
const DynamicScreens = dynamic(() => import('@/components/Ui-components/Dynamic-screens'));
const wellPop = cdnImage('mobile-app-new-images/Wellpop.webp');
const p2b = cdnImage('flutter-app/P2b.webp');
const friendSpire = cdnImage('hire-remote-developer/friendspire.webp');
const CardTechnology = dynamic(() => import('@/components/Ui-components/card-technology'));
const MobileProcess = dynamic(() => import('@/components/Ui-components/MobileProcess'));
const development = cdnImage('hybrid-app/Hybrid-App-Development-Process.svg');
import AggregateScript from '@/components/Common/Aggregate-script';
import {CDN_URL, SITE_URL} from '@/constants/urls';
const OurMakeChoice = dynamic(() => import('@/components/Ui-components/OurMakeChoice'));
const LetsDiscuss = dynamic(import('@/components/Ui-components/Lets-discuss'));
const TokenizeHelp = dynamic(() => import('@/components/Ui-components/tokenize-help'));

const Hybrid = (props: any) => {
    const {
        openForm,
        hybridAppBannerBottom,
        hybridAppDecodingData,
        hybridAppDevelopmentBannerPoints,
        hybridAppFAQ,
        hybridAppIndustryData,
        hybridAppMobileProcessData,
        hybridAppServiceData,
        hybridAppStrategyData,
        hybridAppTechnologyData,
        hybridCarsoulData,
        hybridChooseBodyData,
        hybridChooseContentData,
        hybridDataBusinesses,
        hybridFriendSpireButtonData,
        hybridFriendSpireCheckPoint,
        hybridKeyStrategy,
        wellPopCheckpoint,
        flutterP2BButtonData,
        flutterP2BCheckPoint,
        flutterWellPopButtonData
    } = props;

    return (
        <Box className="hybrid-app-main-parent">
            <PageHead meta={HYBRID_META_DATA} url="/hybrid-app-development" />
            <Banner
                priority={true}
                handleClickOpen={openForm}
                heading="Hybrid App Development Company"
                subheading="Struggling to manage separate apps for iOS and Android? Our hybrid app development services create high-performance, cross-platform applications that deliver native-like experiences, faster launches, and reduced costs while helping your business scale efficiently across devices."
                button="Contact Our Experts"
                image={cdnImage('hybrid-app/Hybrid-App-Development-Company.webp')}
                bannerClass=""
                alt="Hybrid App Development Company"
                DataPoints={hybridAppDevelopmentBannerPoints}
            />
            <Box className="sub-banner-wrapper sub-banner-bottom-wrapper">
                <MUIContainer>
                    <Grid container spacing={2} alignItems="center" justifyContent="space-between" className="white-label-bottom-container">
                        <Grid item md={2} lg={1.7} sm="auto" xs={12}>
                            <Typography className="banner-bottom-heading">Our Strategic Partners</Typography>
                        </Grid>
                        {hybridAppBannerBottom?.map((data: any, index: number) => (
                            <Grid item sm="auto" xs={6} className="sub-banner-images" key={index + 1}>
                                <Box className="images-banner-bottom">
                                    <DisplayImage src={data.src} alt={data.alt} />
                                </Box>
                            </Grid>
                        ))}
                    </Grid>
                </MUIContainer>
            </Box>
            <Grid item xs={12} className="bottom-margin top-space decording-main-wrapper mobile-top-padding mobile-bottom-margin">
                <MUIContainer>
                    <Decoding
                        imageSrc={auditImg}
                        alt="Hybrid App Development Company: Unified Codebase, Maximum Business Impact"
                        heading="Hybrid App Development Company: Unified Codebase, Maximum Business Impact"
                        subHeading={hybridAppDecodingData}
                        imgSx={{maxWidth: 460}}
                        buttonText="Connect with Our Experts Today!"
                        openForm={openForm}
                    />
                </MUIContainer>
            </Grid>
            <Grid item xs={12} className="helper-section">
                <Box className="helper_section_parent bottom-spacing top-space mobile-top-padding mobile-bottom-padding">
                    <MUIContainer>
                        <Box className="spectrum-header-wrapper solutions">
                            <Typography className="spectrum-heading color-black our-service-main-heading text-align-left" component="h2">
                                Hybrid App Development Services Crafted for Enterprise Success
                            </Typography>
                            <Box className="divder-wrapper">
                                <hr className="divider-line divider-line-left" />
                            </Box>
                            <Box className="sub-heading-box" pb={4}>
                                <Typography className="spectrum-sub-heading color-black spacing">
                                    At Debut Infotech, we offer a comprehensive suite of hybrid app development services that address the
                                    full application lifecycle—from ideation and design to post-launch support. Our hybrid solutions are
                                    engineered for scalability, speed, and cross-platform consistency—ensuring your business stays
                                    competitive in an ever-evolving digital landscape.
                                </Typography>
                            </Box>
                        </Box>
                        <Grid container spacing={2}>
                            <HelperSection data={hybridAppServiceData} className="home-helper-card" />
                        </Grid>
                    </MUIContainer>
                </Box>
            </Grid>
            <Box className="top-space mobile-top-padding">
                <LatestCTA
                    heading="Struggling to Manage Separate Android and iOS Codebases?"
                    subheading="Create a unified hybrid application that runs seamlessly across platforms, accelerates time-to-market, and minimizes development overhead."
                    buttonText="Let’s Discuss Your Project"
                    openForm={openForm}
                    className="blue-background-cta"
                />
            </Box>
            <Grid item xs={12} className="blockchain-revolution-service bottom-spacing top-space mobile-top-padding mobile-bottom-padding">
                <MUIContainer>
                    <Platforms
                        data={hybridAppStrategyData}
                        heading="Strategic Benefits of Hybrid App Development for Scalable Growth"
                        subheading="Hybrid app development simplifies the mobile journey for businesses by combining speed, cost-efficiency, and cross-platform compatibility. Our hybrid mobile solutions are designed to help you build once and deploy everywhere—accelerating innovation without compromising quality."
                        containerClass="blockchain-card-container"
                        className="platform-key-industry-service no-border"
                    />
                </MUIContainer>
            </Grid>
            <Grid item xs={12} className="helper-section">
                <Box className="helper_section_parent bottom-spacing top-space mobile-top-padding">
                    <Grid container spacing={2} className="our-service-defi-wrapper">
                        <OurServices
                            ourServices={hybridKeyStrategy}
                            className="service-shadow-border-box enterprise-key-card"
                            containerClass="card-heading-spacing"
                            heading="Key Strategic Features That Power Our Hybrid Mobile App Solutions"
                            subheading="Our hybrid applications are engineered for speed, consistency, and enterprise scalability. At Debut Infotech, we build cross-platform apps that solve real business problems—from high development costs to fragmented user experiences—while offering the flexibility to evolve with market demands."
                        />
                    </Grid>
                </Box>
            </Grid>
            <Box className="bottom-spacing  mobile-bottom-padding top-space mobile-top-padding">
                <LatestCTA
                    heading="Unsure Which Mobile Strategy Best Fits Your Business Goals?"
                    subheading="Get tailored guidance on choosing between native, hybrid, or cross-platform approaches to achieve maximum ROI and scalability."
                    buttonText="Get Expert Consultation"
                    openForm={openForm}
                    className="blue-background-cta"
                />
            </Box>
            <Grid item xs={12} className="dynmaic-white-label-wrapper  dynamic-bep20-wrapper bottom-spacing  mobile-bottom-padding">
                <MUIContainer>
                    <Box className="spectrum-header-wrapper solutions">
                        <Typography className="spectrum-heading color-black " component="h2">
                            Our Exclusive App Development Portfolio
                        </Typography>
                        <Box className="divder-wrapper">
                            <hr className="divider-line" />
                        </Box>
                    </Box>

                    <DynamicScreens
                        imageSrc={wellPop}
                        subHeading="WellPoP"
                        heading="An IoT-Powered Healthcare Management Platform"
                        subPoints={[
                            'Debut Infotech developed WellPoP, an advanced healthcare management platform designed to address fragmentation in the healthcare sector. The system integrates IoT technology to track patient activities and enhance data-driven care management.'
                        ]}
                        reverseOrder={true}
                        alt="WellPoP"
                        checkItems={wellPopCheckpoint}
                        buttonData={flutterWellPopButtonData}
                        caseStudy={true}
                        openForm="/case-study/wellpop"
                        imageClass="dynamic-exchange-image"
                        buttonLabel="View Case Study"
                        buttonClass="nft-button"
                    />
                    <DynamicScreens
                        imageSrc={p2b}
                        subHeading="P2B"
                        heading="An Innovative Solution Simplifying Procurement for the Mining Sector"
                        subPoints={[
                            'Debut Infotech partnered with P2B to build a robust <a target="_blank" href="/saas-development-company">SaaS</a>-based procurement management platform tailored for the mining industry. Designed with a mobile-first approach, P2B helps enterprises overcome inefficiencies tied to traditional procurement systems. From automating approval workflows to enhancing order traceability, the solution brings speed, transparency, and simplicity to a paper-heavy industry.'
                        ]}
                        reverseOrder={false}
                        alt="P2B"
                        checkItems={flutterP2BCheckPoint}
                        buttonData={flutterP2BButtonData}
                        caseStudy={true}
                        openForm="/case-study/p2b"
                        buttonLabel="View Case Study"
                        buttonClass="helper-card-button"
                        imageClass="dynamic-exchange-image"
                    />
                    <DynamicScreens
                        imageSrc={friendSpire}
                        subHeading="Friendspire"
                        heading="A Personalized Entertainment Recommendation Solution"
                        subPoints={[
                            'A dynamic solution to enhance the way people discover and share recommendations with friends, empowering them to curate personalized lists of their favorite books, movies, TV shows, podcasts, and more. Our developers took the project from prototype to full deployment, ensuring a seamless user experience and comprehensive features for personalized content sharing.'
                        ]}
                        reverseOrder={true}
                        alt="Friendspire"
                        buttonData={hybridFriendSpireButtonData}
                        checkItems={hybridFriendSpireCheckPoint}
                        imageClass="dynamic-exchange-image"
                        caseStudy={true}
                        openForm="/case-study/friendspire"
                        buttonLabel="View Case Study"
                        buttonClass="nft-button"
                    />
                </MUIContainer>
            </Grid>
            <Grid
                item
                xs={12}
                className="bottom-spacing generative-tech-wrapper mobile-bottom-padding top-space mobile-top-padding helper_section_parent"
            >
                <CardTechnology
                    heading="Tools & Technologies Our Debut Team Uses to Build Hybrid Apps"
                    subheading="We employ industry-leading tools and frameworks to develop high-performing, cross-platform hybrid applications. Our hybrid app development services focus on maximizing code reusability, enhancing user experience, and accelerating deployment across platforms."
                    data={hybridAppTechnologyData}
                />
            </Grid>
            <Box className="bottom-spacing  mobile-bottom-padding top-space mobile-top-padding ">
                <LatestCTA
                    heading="Looking to Cut App Development Time and Costs?"
                    subheading="Leverage hybrid frameworks to launch faster, maintain easily, and deliver a consistent user experience across all devices."
                    buttonText="Consult Our Specialists Today"
                    openForm={openForm}
                    className="blue-background-cta"
                />
            </Box>
            <Box className="bottom-spacing mobile-bottom-padding helper_section_parent top-space mobile-top-padding">
                <MUIContainer>
                    <TokenizeHelp
                        heading="Industries That Benefit Most from Hybrid App Development Services"
                        subheading="As a leading hybrid app development company, Debut Infotech empowers organizations to unify their digital ecosystems through cross-platform applications that balance scalability, performance, and cost efficiency. Our hybrid solutions help industries modernize customer experiences, accelerate digital transformation, and achieve operational excellence across mobile environments."
                        contentData={hybridAppIndustryData}
                    />
                </MUIContainer>
            </Box>

            <Grid item xs={12} className="blockchain-revolution-service bottom-spacing top-space mobile-top-padding mobile-bottom-padding">
                <MUIContainer>
                    <Platforms
                        data={hybridDataBusinesses}
                        heading="Types of Hybrid Apps We Develop for Modern Businesses"
                        subheading="Our hybrid mobile app development services help businesses deliver seamless cross-platform applications with faster development cycles and lower costs. We specialize in building industry-focused hybrid apps that combine functionality, scalability, and native-like user experiences."
                        containerClass="blockchain-card-container"
                        className="platform-key-industry-service no-border"
                    />
                </MUIContainer>
            </Grid>
            <Box className="">
                <LatestCTA
                    heading="Need Help Choosing the Right Hybrid Framework?"
                    subheading="Our experts evaluate your product goals and recommend the ideal framework to balance performance, scalability, and cost efficiency."
                    buttonText="Schedule a Consultation Now"
                    openForm={openForm}
                    className="blue-background-cta"
                />
            </Box>
            <Box className="bottom-spacing process-mobile-bottom-padding top-space mobile-top-padding">
                <MUIContainer>
                    <Box className="spectrum-header-wrapper solutions">
                        <Typography className="spectrum-heading color-black text-align-left" component="h2">
                            From Idea to Multi-Platform Launch: Our Hybrid App Development Process
                        </Typography>
                        <Box className="divder-wrapper">
                            <hr className="divider-line divider-line-left" />
                        </Box>
                        <Box className="sub-heading-box" pb={4}>
                            <Typography className="spectrum-sub-heading color-black spacing text-align-left" component="p">
                                Our enterprise-grade hybrid app development process focuses on delivering scalable, secure, and
                                high-performing applications that meet complex business requirements while ensuring faster time-to-market.
                            </Typography>
                        </Box>
                    </Box>
                    <Box textAlign="center">
                        <DisplayImage
                            src={development}
                            alt="Hybrid App Development Process"
                            className="approach-main-img approach-web-img"
                        />
                    </Box>
                    <Box className="approach-main-img approach-mobile-img">
                        <MobileProcess mobileProcess={hybridAppMobileProcessData} />
                    </Box>
                </MUIContainer>
            </Box>
            <OurMakeChoice
                heading="Why Choose Debut Infotech"
                subheading="as Your Hybrid App Development Company?"
                body={hybridChooseBodyData}
                contentData={hybridChooseContentData}
            />
            <Grid item xs={12} className="bottom-spacing">
                <LetsDiscuss
                    heading="Ready To Simplify Cross-Platform App Development?"
                    subheading="Build high-performance hybrid applications that deliver seamless user experiences while reducing development time and costs for your business."
                    btnLabel="Contact Our Experts Now"
                    className="white-label-sprill"
                    openForm={() => {
                        globalThis.open('/contact-us', '_blank');
                    }}
                />
            </Grid>

            <Grid item xs={12} className="android-questions background-grey bottom-spacing top-space mobile-top-padding">
                <MUIContainer>
                    <Questions accordianData={hybridAppFAQ} subpart={true} />
                </MUIContainer>
            </Grid>

            <Grid item xs={12}>
                <Box className="top-space mobile-top-padding bg-blue-background">
                    <Testimonials heading="Our Clients Describe Us Best" clientData={hybridCarsoulData} />
                </Box>
            </Grid>

            <Grid item xs={12} className="latest-insights top-space mobile-top-padding">
                <LatestInsights id="18" />
            </Grid>
            <AggregateScript
                name="Hybrid Mobile App Development"
                image={`${CDN_URL}?url=%2Fimages%2Fhybrid-app%2FHybrid-App-Development-Company.webp&w=750&q=75`}
                description="Hybrid mobile app development combines the best of web and native apps, enabling faster development, cross-platform compatibility, and cost-efficiency for businesses targeting iOS and Android users with a single codebase."
                offers={{
                    '@type': 'AggregateOffer',
                    url: `${SITE_URL}/hybrid-app-development`,
                    priceCurrency: 'USD',
                    lowPrice: '50000',
                    highPrice: '1000000',
                    offerCount: '15'
                }}
                aggregateRating={{
                    '@type': 'AggregateRating',
                    ratingValue: '4.8',
                    bestRating: '5',
                    worstRating: '2',
                    ratingCount: '499'
                }}
            />
            <script
                type="application/ld+json"
                id="ai-as-a-service"
                dangerouslySetInnerHTML={{
                    __html: JSON.stringify({
                        '@context': 'https://schema.org',
                        '@type': 'FAQPage',
                        mainEntity: [
                            {
                                '@type': 'Question',
                                name: 'What is hybrid mobile app development?',
                                acceptedAnswer: {
                                    '@type': 'Answer',
                                    text: 'Hybrid mobile app development involves creating apps that work across multiple platforms (iOS and Android) using a single codebase. It combines web technologies like HTML, CSS, and JavaScript with native device features via frameworks. Businesses often prefer hybrid apps due to faster delivery, easier maintenance, and consistent user experience across platforms compared to traditional iOS app development or Android app development.'
                                }
                            },
                            {
                                '@type': 'Question',
                                name: 'How are hybrid apps different from native iOS and Android apps?',
                                acceptedAnswer: {
                                    '@type': 'Answer',
                                    text: 'Hybrid apps are built using a single codebase and can run on both iOS and Android platforms, while native apps require separate codebases for each. Hybrid apps offer faster development, lower maintenance, and reduced mobile app development cost compared to fully native apps. They also allow businesses to reach a wider audience without duplicating development efforts.'
                                }
                            },
                            {
                                '@type': 'Question',
                                name: 'Which platforms are ideal for hybrid app development?',
                                acceptedAnswer: {
                                    '@type': 'Answer',
                                    text: 'Popular platforms used by any modern hybrid mobile development company include React Native, Flutter, Ionic, and Xamarin. These platforms help create robust cross-platform apps with native-like performance. The choice of platform depends on project complexity, performance expectations, and integration requirements. Our team selects the platform that fits your specific business goals and technical requirements.'
                                }
                            },
                            {
                                '@type': 'Question',
                                name: 'Can I convert my existing web app into a hybrid app?',
                                acceptedAnswer: {
                                    '@type': 'Answer',
                                    text: 'Yes, most web apps can be converted into hybrid apps by leveraging hybrid mobile app development frameworks like Ionic or React Native. The process involves reusing your existing web components, optimizing UI/UX for mobile, and adding native plugins. This method allows you to quickly transform your web solution into a scalable hybrid mobile application without starting from scratch.'
                                }
                            },
                            {
                                '@type': 'Question',
                                name: 'How do you secure user data in hybrid applications?',
                                acceptedAnswer: {
                                    '@type': 'Answer',
                                    text: `As a trusted hybrid application development company, we ensure all apps are equipped with robust security layers, safeguarding both user and business data from potential threats. We follow industry best practices to secure hybrid apps.
End-to-end encryption for data transmission
Secure API integrations
Implementation of authentication protocols
Compliance with data protection standards`
                                }
                            },
                            {
                                '@type': 'Question',
                                name: 'What is the typical timeline for hybrid app development?',
                                acceptedAnswer: {
                                    '@type': 'Answer',
                                    text: 'The timeline for hybrid app development varies depending on features, complexity, and integrations. A basic hybrid app may take 8–12 weeks, while enterprise-level solutions could take 4–6 months. Our hybrid mobile app development services are designed to optimize timelines by using reusable components and cross-platform techniques while ensuring quality and performance.'
                                }
                            },
                            {
                                '@type': 'Question',
                                name: 'How much does hybrid app development cost?',
                                acceptedAnswer: {
                                    '@type': 'Answer',
                                    text: 'Hybrid app development cost depends on factors like features, UI/UX complexity, backend integration, and third-party services. Compared to native development, hybrid apps typically reduce mobile app development cost by 30%–40% due to the use of a single codebase. For an accurate estimate, you should consult a professional hybrid app development company based on your project scope.'
                                }
                            },
                            {
                                '@type': 'Question',
                                name: 'How can I hire dedicated developers for my hybrid app project?',
                                acceptedAnswer: {
                                    '@type': 'Answer',
                                    text: 'You can hire mobile developers through a flexible engagement model. At Debut Infotech, we offer dedicated hybrid mobile developers with expertise in cross-platform frameworks, API integration, and enterprise mobility solutions. Whether you need part-time, full-time, or project-based developers, we customize hiring models to fit your specific requirements and development goals.'
                                }
                            },
                            {
                                '@type': 'Question',
                                name: 'What is the best hybrid app framework?',
                                acceptedAnswer: {
                                    '@type': 'Answer',
                                    text: 'The choice of framework depends on project requirements. Leading hybrid mobile app development tools include React Native for high-performance apps, Flutter for expressive UI, Ionic for web-driven applications, and Xamarin for Microsoft ecosystem integrations. Each framework has its unique advantages, and our team selects the one best suited to your business needs.'
                                }
                            },
                            {
                                '@type': 'Question',
                                name: 'Which language type is used for hybrid apps?',
                                acceptedAnswer: {
                                    '@type': 'Answer',
                                    text: 'Hybrid apps primarily use web languages such as HTML5, CSS3, and JavaScript. These are combined with frameworks that allow access to native features. As a hybrid mobile application development company, we utilize modern technologies like TypeScript, React, and other libraries to ensure hybrid apps perform well across platforms while maintaining native-like functionality.'
                                }
                            }
                        ]
                    })
                }}
            />
        </Box>
    );
};

export default Hybrid;
Hybrid.Layout = 'Main';
